import React from 'react';

const AmericanFlag = ({ width = 40, height = 24, style = {} }) => {
    // Proper US flag proportions
    const flagWidth = width;
    const flagHeight = height;
    const stripeHeight = flagHeight / 13;
    const unionHeight = stripeHeight * 7;
    const unionWidth = flagWidth * 0.4;
    
    return (
        <svg 
            width={flagWidth} 
            height={flagHeight} 
            viewBox={`0 0 ${flagWidth} ${flagHeight}`}
            style={{
                border: '1px solid #ccc',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                ...style
            }}
            xmlns="http://www.w3.org/2000/svg"
        >
            {/* Red and White Stripes */}
            {[...Array(13)].map((_, index) => (
                <rect
                    key={`stripe-${index}`}
                    x="0"
                    y={index * stripeHeight}
                    width={flagWidth}
                    height={stripeHeight}
                    fill={index % 2 === 0 ? "#BF0A30" : "#FFFFFF"}
                />
            ))}
            
            {/* Blue Union */}
            <rect
                x="0"
                y="0"
                width={unionWidth}
                height={unionHeight}
                fill="#002868"
            />
            
            {/* Stars - 50 stars in 9 rows (6-5-6-5-6-5-6-5-6 pattern) */}
            {(() => {
                const stars = [];
                const starRows = [6, 5, 6, 5, 6, 5, 6, 5, 6];
                const starSize = unionWidth / 16;
                const xSpacing = unionWidth / 12;
                const ySpacing = unionHeight / 10;
                
                starRows.forEach((starsInRow, rowIndex) => {
                    const xOffset = starsInRow === 6 ? xSpacing : xSpacing * 1.5;
                    for (let i = 0; i < starsInRow; i++) {
                        const x = xOffset + i * xSpacing * 2;
                        const y = ySpacing + rowIndex * ySpacing;
                        
                        // Create five-pointed star path
                        const createStarPath = (cx, cy, r) => {
                            const points = [];
                            for (let i = 0; i < 10; i++) {
                                const radius = i % 2 === 0 ? r : r * 0.4;
                                const angle = (Math.PI / 5) * i - Math.PI / 2;
                                const x = cx + radius * Math.cos(angle);
                                const y = cy + radius * Math.sin(angle);
                                points.push(`${x},${y}`);
                            }
                            return `M${points.join(' L')}Z`;
                        };
                        
                        stars.push(
                            <path
                                key={`star-${rowIndex}-${i}`}
                                d={createStarPath(x, y, starSize)}
                                fill="#FFFFFF"
                            />
                        );
                    }
                });
                
                return stars;
            })()}
        </svg>
    );
};

export default AmericanFlag;